import { DEFAULT_ID } from '@usas/ui-web/utils/Constants';

export const localValidate = (formState) => {
  let errors = {};

  // Full/Part Time
  if (formState.hasCoachRole === true) {
    if (formState.coachTypeCode === DEFAULT_ID || formState.coachTypeCode === '') {
      errors.coachTypeCode = 'Must make a selection';
    }
  }

  return errors;
};

const ClubStaffEditFormValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
}

export default ClubStaffEditFormValidation;